export default {
  nav: {
    home: "首页",
    commitment: "社会承诺",
    development: "公司发展",
    quality: "质量保障",
    policy: "品质方针",
    target: "品质目标",
    authentication: "品质认证",
    category: "产品种类",
    housing: "住宅建设用品",
    daily: "生活用品",
    kitchen: "厨房用品",
    shower: "浴室用品",
    electric: "电气用品",
    construction: "建筑车辆等用品",
    technology: "技术工艺",
    production: "社内开发",
    sensing: "公司设备",
    forming: "注塑成形",
    sheet_metal_forming: "冲压加工",
    sheet_metal: "钣金工艺",
    welding: "焊接工艺",
    packaging: "组装工艺",
    mould: "模具加工",
    cooperative: "合作客户",
    contact: "联系我们"
  },
  contact: {
    title: "联系方式",
    address_title: "公司地址",
    address: "上海市松江工业区联阳路598号"
  },
  quick_link: {
    title: "快速链接"
  },
  banner: {
    "1_title": "ALL Round.",
    "1_con": "无论什么都可交给我们。这是上海坂井的“自信”。<br>金属、塑料、复合材料加工的专业集团，上海坂井经过多年经验及彻底的品质管理，可满足客户多样的需求。",
    "2_title": "In Your Life",
    "2_con": "上海坂井的产品，也许并不起眼，但在你的生活中不可或缺。<br>为了大家安全舒适的生活，我们始终在持续改进中。"
  },
  commitment: {
    main_title: "企业社会责任",
    main_con: "以人为本，绿色运营，不断改善员工的工作环境，让员工有幸福美好的生活， 促进经济、社会、环境的和谐与可持续发展做出贡献。",
    "1_title": "善待环境",
    "1_con": "通过节能减排，发展低碳和循环经济，提高水资源的重复利用，不断实施技术和工艺创新，提高效率。实现持续发展，回馈社会，创造更多的就业机会。",
    "2_title": "保障作业安全，减少风险",
    "2_con": "提供安全的作业环境，提供劳动保护，确保员工在工作场所不受伤害；对各生产线、职业危害因素进行环境、健康与安全危害辨识与风险评估，加强员工安全培训。",
    "3_title": "诚信经营，实现共赢发展",
    "3_con": "公司产品、服务等各方面达到或超过客户的要求；保证客户的商业利益不受损害；坚持公平交易，反贪污贿赂，与客户和行业竞争者实现共赢发展；自觉维护市场秩序，依法纳税；不断提升社会和环境标准；根据本方针，各部门密切配合。通过规范公司内控和公司资讯透明，为社会创造合理回报。",
    "4_title": "消除歧视，提升职业能力",
    "4_con": "消除用工歧视；不雇佣童工；为员工创造快乐工作、舒适工作的生活环境；制定和实施《女职工劳动保护规定》，促进男女平等就业、晋升，严禁性别歧视；组织各类人员参加培训，提升员工整体素质、职业能力和发展空间。"
  },
  quality: {
    policy_title: "品质方针",
    policy_con: "生产客户信赖，满意的产品",
    target_title: "品质目标",
    target_con_1: "以顾客为中心，达成客户要求",
    target_con_2: "符合国际标准规格的品质管理，品质保证",
    target_con_3: "以顾客为中心，达成客户要求",
    authentication_title: "品质认证",
    authentication_con: [{
        title: "1999",
        icon: ["t19001", "iaf", "cnas"],
        con: "方圆认证机关标识<br>1999年10月取得质量管理体系资格ISO-9001"
      },
      {
        title: "2007",
        icon: ["ul", "ccc"],
        con: "2007年1月取得ＵＬ美国保险业者安全试验所认证资格<br>2007年4月取得中国（ＣＣＣ）強制认证"
      },
      {
        title: "2013",
        icon: ["t24001", "iaf", "cnas-2"],
        con: "方圆认证机关标识<br>2013年5月取得环境管理体系资格ISO-14001"
      },
      {
        title: "2018",
        icon: ["t24001", "iaf-2", "cnas-3"],
        con: "2018年取得2015版质量/环境管理体系资格"
      }
    ],
    flow_title: "上海坂井的品质从深度了解客户开始",
    flow_con: [{
        title: "与客户的交涉",
        con: "我们认为，完全理解顾客的要求比什么都重要。上海坂井以“站在客户角度考虑”为首要。"
      },
      {
        title: "设计试作",
        con: "设计是发挥了与设计相同的规格，还是没有错误，长年的经验制作出最适合的形状。"
      },
      {
        title: "样品交涉",
        con: "与客人一起花充足时间进行讨论。各阶段不留有疑点的地方··，这是上海坂井制作的产品受到高度信赖的理由。"
      },
      {
        title: "变更改善",
        con: "根据顾客的意见加以改善。是最终迎来量产的最后工程。不妥协是上海坂井技术员的闪亮点。"
      },
      {
        title: "生产",
        con: "制作出了能够进行量产的样品，终于可以进行生产。严格的品质管理支撑着上海坂井的品质。"
      },
      {
        title: "检查",
        con: "以人、眼睛、手、高效率的检验治具进行最后的检查。不生产不良品，且绝不流出不良品，这是上海坂井生产产品的基本。"
      },
      {
        title: "交货",
        con: "对于上海坂井来说，交货并不是结束，而是对下一步的提高。并接受客户意见，积累产品的改良技术。"
      }
    ]
  },
  sheet_metal_forming: {
    con: [
      "冲压加工，是本公司的四大业务之一，在上海已有近20年的实际业绩和经验。",
      "可按客户订单量提供顺送，单发，平面加工方案，可自信答复客户提出的任何要求。拉深加工品，可以加工到产品直径的2倍左右，并且可以用日语交流，任何问题都可以提出来。"
    ]
  },
  welding: {
    con: [
      "焊接加工，是本公司的四大业务之一，在上海已有近20年的实际业绩和经验。建材、汽车零件、日用品等涉及范围非常广泛。",
      "焊接加工不可避免是产品的热变形，可经自社设计的焊接冶具按精度要求进行校正。焊接强度通过对焊接量、脚长、焊接条件管理及进行抽取破坏试验，构筑了100%的保证体制。"
    ]
  },
  production: {
    con: [
      "本公司也可开发自动化设备，削减成本和提高品质。",
      "本公司考虑到中国不稳定的商务环境，竭力进行内制化、自动化，为客户提供稳定、高品质的产品。"
    ]
  },
  sensing: {
    table_title: {
      name: '机械名称',
      vender: "厂家",
      num: "台数"
    },
    con: "以多年的实际经验，技术及各种设备来满足客人的各种需求。"
  },
  sheet_metal: {
    tips: "（折弯、整形、铆接加工、研磨、镜面处理、线切割）",
    con: [
      "折弯加工适合小批量品的加工，不需要制作模具。",
      "铆接加工与焊接相比，强度略差些，但是一种环保且低成本的接合方法。可根据产品的接合强度进行建议。特别对不锈钢的表面加工有着非常丰富的经验。适用所有种类的表面外观。"
    ]
  },
  forming: {
    con: [
      "注塑成形，是本公司的四大业务之一，在上海已有近20年的实际业绩和经验。",
      "配备了100t~1300t的成形机，可以自信的回答客户的任何要求。"
    ]
  },
  packaging: {
    con: [
      "组装，是将本公司的四大业务的整合，通过「冲压+焊接+成形」制作的部品组装后，产品的附加值得到提高。",
      " 经过组装后完成品或者组件，通过国内卡车运输及集装箱出口，送至客户手上.(本公司有出口贸易权）最终组装好后完成品，与日语印刷的使用说明书一起，负责出货至指定客户。"
    ]
  },
  mould: {
    con: [
      "本公司设有模具加工部门，不仅能开发新项目，且在量产后也能迅速对应。",
      "引进CAD・CAM技术，能够进行高精度的加工。好的模具生产出好的产品。"
    ]
  },
  cooperative: {
    title: "主要客户及产品介绍",
    inland_title: "合作客户（国内）",
    foreign_title: "合作客户（国外）",

    inland_1: "骊住贸易(上海)有限公司",
    inland_1_con: "车棚支架，侧板，阳台部品，信箱桶，洗脸架，门用特殊螺母",
    inland_2: "骊住建材(上海)有限公司",
    inland_2_con: "车棚支架，侧板，阳台部品，信箱桶，洗脸架，门用特殊螺母",
    inland_3: "东陶(上海)有限公司",
    inland_3_con: "浴室用，洗手间用三乾王，马桶坐，马桶盖",
    inland_4: "东理化汽车电子(上海)有限公司",
    inland_4_con: "挖掘机驾驶室内装品，操作杆",
    inland_5: "上海日立家用电器有限公司",
    inland_5_con: "洗衣机用塑料部品，马达轴承部品",
    inland_6: "南京日立产机有限公司",
    inland_6_con: "控制箱",
    inland_7: "松下住宅电器(上海)有限公司",
    inland_7_con: "按摩椅部品",
    inland_8: "村田汽车塑料零部件(上海)有限公司",
    inland_8_con: "蓄电池槽",
    inland_9: "上海小里机材有限公司",
    inland_9_con: "送风机连接部品",
    inland_10: "三菱电机自动化机器制造(常熟)有限公司",
    inland_10_con: "伺服放大器",
    inland_11: "深圳市裕兴实业有限公司",
    inland_11_con: "厨房用部品",
    inland_12: "伊予金属制品(上海)有限公司",
    inland_12_con: "乐器部品",
    inland_13: "蕯那电子(上海)有限公司",
    inland_13_con: "萤光灯部品",

    foreign_1: "富士工业(株)",
    foreign_1_con: "排油烟机",
    foreign_2: "TOTO(株)",
    foreign_2_con: "浴室用，洗手间用三乾王",
    foreign_3: "TOTOバスクリエイト(株)",
    foreign_3_con: "车用遮挡板",
    foreign_4: "(株)东海理化クリエイト",
    foreign_4_con: "挖掘机驾驶室内装品，操作杆",
    foreign_5: "パナソニック　エイジフリー(株)",
    foreign_5_con: "护理用小凳子，撑板，移动台",
    foreign_6: "日立アプライアンス(株)",
    foreign_6_con: "洗衣服干燥机用架子",
    foreign_7: "(株)ハウステック",
    foreign_7_con: "厨房、卫生机器部品",
    foreign_8: "クリナップ(株)",
    foreign_8_con: "成套厨房抽屉用部品",
    foreign_9: "シャ-プ(株)",
    foreign_9_con: "洗衣服干燥机用架子",
    foreign_10: "(株)トヨウラ",
    foreign_10_con: "厨房用不锈钢部品",
    // foreign_11: "(株)电技商会",
    // foreign_11_con: "电线束",
    foreign_11: "(株)カクダイ",
    foreign_11_con: "洗衣机垫板"
  },
  development: {
    main_title: "半世纪的历史，走向世界的坂井集团",
    outline_title: "上海坂井概要",
    history_title: "集团历史"
  },
  development_outline: [{
      title: "公司名",
      con: "上海坂井塑料成形有限公司"
    },
    {
      title: "地址",
      con: "上海市松江工业区联阳路598号"
    },
    {
      title: "TEL",
      con: "021-5774-1131"
    },
    {
      title: "FAX",
      con: "021-5774-0636"
    },
    {
      title: "资本金",
      con: "1,127.8万 USD"
    },
    {
      title: "投资总额",
      con: "1,427.8万 USD"
    },
    {
      title: "资本内容",
      con: "独资企业<br>泉商事株式会社　15.3％<br>株式会社トヨウラ　70.05％<br>富士工业株式会社　13.65％"
    },
    {
      title: "占地面积",
      con: "15,748m2"
    },
    {
      title: "从业员",
      con: "200名"
    },
    {
      title: "设立",
      con: "设立日期　1996年3月19日<br>开工日期　1996年11月15日"
    },
    {
      title: "经营内容",
      con: "【加工技术】<br>塑料成形加工、金属冲压、钣金加工、焊接加工、管子加工（切断、弯曲、研磨、抛光、焊接），部品、产品组装、模具产品（金属冲压模具、注塑模具）的制造、销售<br>【商品】<br>护理用品、生活用品、厨房用品、住宅建材用品、电器用品等的住宅商品、建设机械的内部装饰品、产业机械零部件、汽车的内部装饰品等的制造、销售"
    }
  ],
  development_history: [{
      title: "1956",
      con: "泉制作所(现泉商事第一工场)设立<br>开始铁材，钢材产品的生产"
    },
    {
      title: "1967",
      con: "(株)那珂制作所(现泉商事第二工场)设立<br>进入塑料领域"
    },
    {
      title: "1971",
      con: "(株)トヨウラ设立<br>进入以钢材为主体的厨房、浴缸等关联领域"
    },
    {
      title: "1973",
      con: "泉商事(株）设立<br>随着公司的发展，提高了采购、销售的效率"
    },
    {
      title: "1996",
      con: "上海坂井塑料成形有限公司设立<br>开始了家电、住宅设备、汽车、OA机器周边部品、完成品的生产"
    },
    {
      title: "2001",
      con: "上海坂井国际贸易有限公司设立<br>提高了材料进口、完成品出口的效率"
    },
    {
      title: "2005",
      con: "泉商事(株)和(株)泉制作所（第一工场・第二工场)的合并，提高了生产销售的效率及对顾客需求的对应速度。"
    },
    {
      title: "2007",
      con: "(株)トヨウラ大阪营业事务所设立"
    },
    {
      title: "2012",
      con: "(株)トヨウラ东京渋谷ショールーム设立"
    },
    {
      title: "2014",
      con: "总公司迁移(东京都渋谷区）"
    },
    {
      title: "2016",
      con: "(株)トヨウラ福冈营业事务所设立"
    }
  ],
  sensing_plastic: {
    title: "塑料加工相关",

    con: [{
        name: "1300T注塑成形机",
        vender: "三菱重工",
        num: "1"
      }, {
        name: "850T注塑成形机",
        vender: "三菱重工",
        num: "2"
      }, {
        name: "650T注塑成形机",
        vender: "三菱重工",
        num: "1"
      }, {
        name: "650T电动注塑成形机",
        vender: "海天",
        num: "1"
      },
      {
        name: "550T电动注塑成形机",
        vender: "海天",
        num: "1"
      }, {
        name: "550T注塑成形机",
        vender: "三菱重工",
        num: "1"
      }, {
        name: "350T注塑成形机",
        vender: "三菱重工",
        num: "2"
      }, {
        name: "230T电动注塑成形机",
        vender: "海天",
        num: "3"
      }, {
        name: "120T电动注塑成形机",
        vender: "海天",
        num: "2"
      }, {
        name: "热印刷机",
        vender: "日本制",
        num: "2"
      }, {
        name: "丝印机",
        vender: "中国制",
        num: "2"
      }, {
        name: "搅拌机(200kg)",
        vender: "中国制",
        num: "1"
      }, {
        name: "自动丝印机",
        vender: "中国制",
        num: "1"
      }, {
        name: "热印印刷机(P1单色）",
        vender: "上海網諠",
        num: "1"
      }
    ]
  },
  sensing_metal: {
    title: "金属加工相关",
    con: [{
      name: "500T顺送冲压机",
      vender: "金丰",
      num: "1"
    }, {
      name: "200T冲压机（顺送）",
      vender: "AIDA",
      num: "1"
    }, {
      name: "150T冲压机",
      vender: "AIDA",
      num: "13"
    }, {
      name: "110T冲压机",
      vender: "AIDA",
      num: "1"
    }, {
      name: "60T冲压机",
      vender: "中国制",
      num: "2"
    }, {
      name: "45T冲压机",
      vender: "金丰",
      num: "2"
    }, {
      name: "高速冲压机",
      vender: "AMADA",
      num: "1"
    }, {
      name: "100T折弯机",
      vender: "AMADA",
      num: "2"
    }, {
      name: "NC切削机",
      vender: "OKUMA",
      num: "3"
    }, {
      name: "自动弯管机",
      vender: "OPTON（日本制）",
      num: "1"
    }, {
      name: "切割机",
      vender: "中国制",
      num: "1"
    }, {
      name: "抛光机",
      vender: "中国制",
      num: "2"
    }, {
      name: "点焊机",
      vender: "松下",
      num: "4"
    }, {
      name: "氩弧焊机",
      vender: "松下",
      num: "4"
    }, {
      name: "CO2焊接机",
      vender: "松下",
      num: "2"
    }, {
      name: "自动焊接机器人",
      vender: "松下（自社生产）",
      num: "5"
    }, {
      name: "半自动攻丝机",
      vender: "中国制",
      num: "12"
    }, {
      name: "50折弯机",
      vender: "米路加",
      num: "1"
    }, {
      name: "半自动烫螺母机",
      vender: "自社生产",
      num: "1"
    }, {
      name: "网板切割机",
      vender: "自社生产",
      num: "1"
    }, {
      name: "网板热风整形机",
      vender: "自社生产",
      num: "1"
    }, {
      name: "自动组立机",
      vender: "自社生产",
      num: "1"
    }, {
      name: "漏气测试机",
      vender: "自社生产",
      num: "1"
    }, {
      name: "多轴攻丝机",
      vender: "自社生产",
      num: "1"
    }, {
      name: "自动浇口切割机",
      vender: "自社生产",
      num: "1"
    }]
  },
  more: "了解更多",
  housing: [
    "车棚支架加强架",
    "家用百叶门窗安装框",
    "信箱",
    "天窗防水部品",
    "阳台屋顶加强架",
    "阳台屋顶加强架"
  ],
  kitchen: [
    "排油烟机（美国）",
    "过滤器",
    "排风机",
    "灯管",
    "排油烟机（新加坡）",
    "不锈钢槽",
    "厨房网框"
  ],
  daily: [
    "按摩椅脚部",
    "按摩椅脚部",
    "自动升降床",
    "折叠椅",
  ],
  shower: [
    "马桶盖，马桶座",
    "温风干燥机部品",
    "浴室护理用撑板",
    "浴室护理用椅子",
    "座式淋浴",
    "浴室干燥机部品",
    "浴室干燥机部品",
    "西式安全栏杆",
    "洗脸架",
    "洗涤剂架",
    "洗涤剂架",
    "化妆台侧板",
    "移动台"
  ],
  electric: [
    "变频器箱",
    "电表箱",
    "工业用电气部品"
  ],
  construction: [
    "建筑车辆饰品",
    "建筑车辆饰品",
    "车辆遮阳板",
    "车辆遮阳板"
  ]
};